import { render, staticRenderFns } from "./historyConsultation.vue?vue&type=template&id=10e2a165&scoped=true&"
import script from "./historyConsultation.vue?vue&type=script&lang=js&"
export * from "./historyConsultation.vue?vue&type=script&lang=js&"
import style0 from "./historyConsultation.vue?vue&type=style&index=0&id=10e2a165&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e2a165",
  null
  
)

export default component.exports